<template>
	<info-card class="emotion-card">
		<h4>{{ title }}</h4>
		<p v-if="moodDate">{{ moodDate }}</p>
		<div
			class="emotion-sticker bg-contain"
			:style="emotionBackground"
		>
			<p v-if="!sticker">
				No image available
			</p>
		</div>

		<ul>
			<li>
				<h4>{{ bpm || '--'}}</h4>
				<p>BPM</p>
			</li>

			<li>
				<h4>{{ stress || '--' }}</h4>
				<p>Stress Level</p>
			</li>

			<li>
				<h4>{{ mood || '--' }}</h4>
				<p>Mood Meter</p>
			</li>
		</ul>

		<mood-meter :percent="percent"></mood-meter>
	</info-card>
</template>

<script>
import MoodMeter from '@/components/utils/MoodMeter.vue'
import InfoCard from '@/components/layouts/InfoCard.vue'

export default {
	props: {
		title: {
			type: String,
			default: ''
		},

		sticker: {
			type: String,
			default: ''
		},

		bpm: {
			type: Number,
			default: 0
		},

		stress: {
			type: String,
			default: null
		},

		mood: {
			type: String,
			default: null
		},

		moodDate: {
			type: String,
			default: null
		},

		percent: {
			type: Number,
			default: 0
		}
	},

	data () {
		return {
			URL: process.env.VUE_APP_BASE
		}
	},

	computed: {
		emotionBackground () {
			if (!this.sticker) return ''
			return `background-image:url('${this.URL}img/resources/${this.sticker}');`
		}
	},

	components: {
		MoodMeter,
		InfoCard
	}
}
</script>

<style lang="scss" scoped>
.emotion-card {
	height: 100%;
	width: 100%;
}

h4 {
	margin-bottom: 5px;
	text-transform: capitalize;
}

.emotion-sticker {
	height: 150px;
	@include flex-column(center, center);
	width: 100%;
	background-color: $light;
	margin-top: 10px;

	p {
		text-align: center;
		color: #fff;
	}
}
</style>
